import { useState, useEffect, useRef } from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";

export default function BannerSlider({ banners = [] }) {
  const [current, setCurrent] = useState(0);
  const scrollRef = useRef(null);
  const timerRef = useRef(null);

  useEffect(() => {
    if (banners.length <= 1) return;
    timerRef.current = setInterval(() => {
      setCurrent((prev) => (prev + 1) % banners.length);
    }, 4000);
    return () => clearInterval(timerRef.current);
  }, [banners.length]);

  useEffect(() => {
    if (scrollRef.current) {
      const el = scrollRef.current;
      const child = el.children[current];
      if (child) {
        el.scrollTo({ left: child.offsetLeft, behavior: "instant" });
      }
    }
  }, [current]);

  if (!banners.length) return null;

  return (
    <div data-testid="home-banner-slider" className="relative w-full bg-slate-100">
      <div
        ref={scrollRef}
        className="flex overflow-x-auto scrollbar-hide snap-x snap-mandatory"
      >
        {banners.map((banner, i) => (
          <div
            key={banner.id || i}
            className="w-full flex-shrink-0 snap-center aspect-video"
          >
            <img
              src={banner.image_url}
              alt={`Banner ${i + 1}`}
              className="w-full h-full object-cover"
            />
          </div>
        ))}
      </div>
      {banners.length > 1 && (
        <div className="absolute bottom-2 left-0 right-0 flex justify-center gap-1.5">
          {banners.map((_, i) => (
            <button
              key={i}
              onClick={() => setCurrent(i)}
              className={`w-2 h-2 transition-none ${
                i === current ? "bg-[#0284C7]" : "bg-white/60"
              }`}
            />
          ))}
        </div>
      )}
    </div>
  );
}
